// John Eldhose 20200619
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AppBar, BottomNavigation, BottomNavigationAction, Grid, Tab, Tabs, Typography } from '@material-ui/core';
import { Done, Description, Favorite, Restore } from '@material-ui/icons';
import ContentLibrary from './academy/ContentLibrary';
import Course from './academy/Course';
import Home from './academy/Home';
import LearningPath from './academy/LearningPath';
import UsageReport from './academy/UsageReport';
import AcademyUser from '../../actions/AcademyUser';
import { postAcademy } from './academy/lib';
import AcademyPage from '../../actions/AcademyPage';
import { stream } from '../lib/lib';

class App extends Component {

  state = {
    clsearch: {}
  }
  componentWillMount() {
    postAcademy('user', { action: 'get' }, (res) => {
      this.props.AcademyUser('init', res.data);
    });
  }
  demoDays = () => {
    if([2, 10].includes(this.props.isAuth) && this.props.academyDemo > 0) {
      var days = this.props.academyDemo + ' day';
      if(this.props.academyDemo > 1)
        days += 's';
      return (
        <div style={{ paddingRight: '20px', textShadow: '2px 2px 5px red' }}>
          <Typography color='inherit'>Demo Access</Typography>
          <Typography color='inherit'>Expiring in {days}</Typography>
        </div>
      );
    }
    else
      return <div />;
  }
  tabs = ['Academy Home', 'Content Library'];
  handleTab = (eve, val) => {
    this.props.AcademyPage(val, {});
  }
  quickBar = () => {
    if(this.props.page === 'Academy Home')
      return (
        <AppBar position="static" >
          <BottomNavigation
            onChange={this.handleChange}
            showLabels
            color='primary'
          >
            <BottomNavigationAction
              label='In Progress'
              icon={<Restore />}
              onClick={() => this.props.AcademyPage(
                this.props.user.details.progress.page,
                this.props.user.details.progress.parms
              )}
            />
            <BottomNavigationAction
              label='Completed'
              icon={<Done />}
              onClick={() => this.props.AcademyPage(
                'Academy Home', { search: {
                  by: 'completed', completed: this.props.user.details.courses.concat(this.props.user.details.learningpaths)
                } }
              )}
            />
            <BottomNavigationAction
              label='Favorites'
              icon={<Favorite />}
              onClick={() => this.props.AcademyPage(
                'Academy Home', { search: {
                  by: 'favorites', favorites: this.props.user.details.favorites
                } }
              )}
            />
            <BottomNavigationAction
              label='Report'
              icon={<Description />}
              onClick={() => this.props.AcademyPage(
                'Usage Report', {
                  FirstName: this.props.user.FirstName,
                  LastName: this.props.user.LastName,
                  AcademyPage: this.props.AcademyPage
                }
              )}
            />
          </BottomNavigation>
        </AppBar>
      );
    else
      return <div />;
  }
  content = () => {
    switch(this.props.page) {
      case 'Content Library':
        return (
          <ContentLibrary
            search={this.state.clsearch}
            setSearch={(s) => this.setState({ clsearch: s })}
          />
        );
      case 'Courses':
        return <Course parms={this.props.parms} />;
      case 'Learning Paths':
        return <LearningPath parms={this.props.parms} />;
      case 'Usage Report':
        return <UsageReport parms={this.props.parms} />;
      default:
        var d = (typeof this.props.user.details === 'undefined') ? {} : this.props.user.details;
        return (
          <Home
            parms={this.props.parms}
            courses={(typeof d.courses === 'undefined') ? [] : d.courses}
            learningpaths={(typeof d.learningpaths === 'undefined') ? [] : d.learningpaths}
          />
        );
    }
  }

  render() {
    if(
      [3, 15].includes(this.props.isAuth) ||
      ([2, 10].includes(this.props.isAuth) && this.props.academyDemo > 0)
    ) {
      var tabs = [...this.tabs];
      if(!tabs.includes(this.props.page))
        tabs.push(this.props.page);
      return (
        <div>
          <Grid container justify='space-between' alignItems='center'>
            <Grid item xs>
              <img src={stream('academy/images/academy_logo.jpg')} alt='logo' height='55' />
            </Grid>
            <Grid item xs={6}>
              <Typography variant='display1'>
                <font color='#385687'>Carlson Academy</font>
              </Typography>
            </Grid>
            <Grid item xs>
              <Typography>
                Questions/feedback? Please email academy@carlsonsw.com
              </Typography>
            </Grid>
          </Grid>
          <p />
          <AppBar position='static'>
            <Grid container justify='space-between' alignItems='center'>
              <Tabs value={this.props.page} onChange={this.handleTab}>
                {tabs.map(tab => <Tab key={tab} label={tab} value={tab} />)}
              </Tabs>
              {this.demoDays()}
            </Grid>
          </AppBar>
          <p />
          {this.quickBar()}
          {this.content()}
          <p />
        </div>
      );
    }
    else
      return (
        <Grid container justify='center' alignItems='center' style={{ minHeight: '400px' }}>
          <Typography color='error'>
            You do not have access to Academy<br />
            Demo days are expired
          </Typography>
        </Grid>
      );
  }
}

const mapStateToProps = (state) => {
  return ({ page: state.Academy.page, parms: state.Academy.parms, user: state.Academy.user });
}
const mapDispatchToProps = (dispatch) => ({
  AcademyPage: (page, parms) => dispatch(AcademyPage(page, parms)),
  AcademyUser: (prop, user) => dispatch(AcademyUser(prop, user))
});
const Academy = connect(mapStateToProps, mapDispatchToProps)(App);

export default Academy;



// WEBPACK FOOTER //
// ./src/components/home/Academy.js